export const constants = {
  additionalStateKeyInStorage: 'additional_state',
  migrationOnDemandEnabledKeyInStorage: 'migration_on_demand_enabled',
}